import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState({
    users: true,
    content: true,
    tickets: false,
    settings: false
  });

  const toggleMenu = (menu) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menu]: !prev[menu]
    }));
  };

  const isActive = (path) => location.pathname === path;

  const menuItemStyle = (path) => ({
    backgroundColor: isActive(path) ? '#0d6efd' : 'transparent',
    color: isActive(path) ? 'white' : '#333',
    borderRadius: '4px',
    marginBottom: '2px'
  });

  return (
    <div className="bg-light border-end" style={{ width: '250px', minHeight: '100vh' }}>
      <div className="p-3">
        {/* Dashboard */}
        <Link
          className="nav-link d-flex align-items-center py-2 px-3"
          to="/"
          style={menuItemStyle('/')}
        >
          <span className="me-2">📊</span>
          <strong>Dashboard</strong>
        </Link>

        <hr className="my-2" />

        {/* Kullanıcı Yönetimi */}
        <div className="mb-2">
          <div
            className="nav-link d-flex align-items-center justify-content-between py-2 px-3"
            style={{ cursor: 'pointer', backgroundColor: '#e9ecef', borderRadius: '4px' }}
            onClick={() => toggleMenu('users')}
          >
            <span><span className="me-2">👥</span> Kullanıcılar</span>
            <span>{expandedMenus.users ? '▼' : '▶'}</span>
          </div>
          {expandedMenus.users && (
            <ul className="nav flex-column ms-3 mt-1">
              <li className="nav-item">
                <Link className="nav-link py-1 px-3" to="/user-management" style={menuItemStyle('/user-management')}>
                  Kullanıcı Yönetimi
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link py-1 px-3" to="/users" style={menuItemStyle('/users')}>
                  Kullanıcı Listesi
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link py-1 px-3" to="/roles" style={menuItemStyle('/roles')}>
                  Roller
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link py-1 px-3" to="/role-groups" style={menuItemStyle('/role-groups')}>
                  Rol Grupları
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link py-1 px-3" to="/role-group-roles" style={menuItemStyle('/role-group-roles')}>
                  Rol Grup Rolleri
                </Link>
              </li>
            </ul>
          )}
        </div>

        {/* İçerik Yönetimi */}
        <div className="mb-2">
          <div
            className="nav-link d-flex align-items-center justify-content-between py-2 px-3"
            style={{ cursor: 'pointer', backgroundColor: '#e9ecef', borderRadius: '4px' }}
            onClick={() => toggleMenu('content')}
          >
            <span><span className="me-2">📝</span> İçerik</span>
            <span>{expandedMenus.content ? '▼' : '▶'}</span>
          </div>
          {expandedMenus.content && (
            <ul className="nav flex-column ms-3 mt-1">
              <li className="nav-item">
                <Link className="nav-link py-1 px-3" to="/questions" style={menuItemStyle('/questions')}>
                  Sorular
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link py-1 px-3" to="/question-types" style={menuItemStyle('/question-types')}>
                  Soru Tipleri
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link py-1 px-3" to="/tag-types" style={menuItemStyle('/tag-types')}>
                  Etiket Tipleri
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link py-1 px-3" to="/tags" style={menuItemStyle('/tags')}>
                  Etiketler
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link py-1 px-3" to="/membership-packages" style={menuItemStyle('/membership-packages')}>
                  Üyelik Paketleri
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link py-1 px-3" to="/agreements" style={menuItemStyle('/agreements')}>
                  Sözleşmeler
                </Link>
              </li>
            </ul>
          )}
        </div>

        {/* Destek Yönetimi */}
        <div className="mb-2">
          <div
            className="nav-link d-flex align-items-center justify-content-between py-2 px-3"
            style={{ cursor: 'pointer', backgroundColor: '#e9ecef', borderRadius: '4px' }}
            onClick={() => toggleMenu('tickets')}
          >
            <span><span className="me-2">🎫</span> Destek</span>
            <span>{expandedMenus.tickets ? '▼' : '▶'}</span>
          </div>
          {expandedMenus.tickets && (
            <ul className="nav flex-column ms-3 mt-1">
              <li className="nav-item">
                <Link className="nav-link py-1 px-3" to="/tickets" style={menuItemStyle('/tickets')}>
                  Destek Talepleri
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link py-1 px-3" to="/ticket-types" style={menuItemStyle('/ticket-types')}>
                  Destek Tipleri
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link py-1 px-3" to="/ticket-statuses" style={menuItemStyle('/ticket-statuses')}>
                  Destek Durumları
                </Link>
              </li>
            </ul>
          )}
        </div>

        {/* Ayarlar */}
        <div className="mb-2">
          <div
            className="nav-link d-flex align-items-center justify-content-between py-2 px-3"
            style={{ cursor: 'pointer', backgroundColor: '#e9ecef', borderRadius: '4px' }}
            onClick={() => toggleMenu('settings')}
          >
            <span><span className="me-2">⚙️</span> Ayarlar</span>
            <span>{expandedMenus.settings ? '▼' : '▶'}</span>
          </div>
          {expandedMenus.settings && (
            <ul className="nav flex-column ms-3 mt-1">
              <li className="nav-item">
                <Link className="nav-link py-1 px-3" to="/countries" style={menuItemStyle('/countries')}>
                  Ülkeler
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link py-1 px-3" to="/cities" style={menuItemStyle('/cities')}>
                  Şehirler
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link py-1 px-3" to="/culture-texts" style={menuItemStyle('/culture-texts')}>
                  Kelime Yönetimi
                </Link>
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
